import React from 'react';
import PropTypes from 'prop-types';

import dayjs from 'dayjs';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { uniq, without } from 'lodash';

import { DATE_FORMAT } from 'lib/constants';
import { danger, white } from 'lib/css/colors';
import KnownSkuIcon from 'components/global_products/detail_view/KnownSkuIcon';
import LoadingSpinner from 'components/shared/LoadingSpinner';
import ProductUnlinkButton from 'components/global_products/detail_view/ProductUnlinkButton';
import RadioButton from 'components/shared/RadioButton';
import VerificationStatusIcon from 'components/global_products/detail_view/VerificationStatusIcon';
function ManufacturerRow({
  manufacturer,
  refetch,
  selectedIds,
  setSelectedIds,
  linkTypeChangeLogLoading,
  linkTypeChangeLog,
}) {
  const isChecked = selectedIds.manufacturerProducts.includes(manufacturer.id);
  const isKeepArchived = manufacturer?.keep_archived || false;
  // Keep-archived implies archived: a discontinued product always shows the archived state.
  const isArchived = manufacturer?.archived || isKeepArchived;

  const toggleCheck = () => {
    const isChecked = selectedIds.manufacturerProducts.includes(manufacturer.id);
    if (isChecked) {
      setSelectedIds({
        ...selectedIds,
        manufacturerProducts: without(selectedIds.manufacturerProducts, manufacturer.id),
      });
    } else {
      setSelectedIds({
        ...selectedIds,
        manufacturerProducts: uniq([...selectedIds.manufacturerProducts, manufacturer.id]),
      });
    }
  };

  return (
    <tr key={manufacturer.id} className={isArchived ? 'text-muted' : ''}>
      <td>
        <RadioButton
          box
          className="align-middle"
          small={true}
          checked={isChecked}
          onClick={() => toggleCheck()}
        />
      </td>
      <td>
        <KnownSkuIcon
          knownSku={manufacturer.known_sku}
          productId={manufacturer.id}
          refetch={refetch}
        />
      </td>
      <td>
        {isArchived ? (
          <OverlayTrigger
            overlay={<Tooltip>Product is archived.</Tooltip>}
            placement="top"
            delayShow={300}
            delayHide={150}
          >
            <span>{manufacturer.global_manufacturer.name}</span>
          </OverlayTrigger>
        ) : (
          manufacturer.global_manufacturer.name
        )}
        {isKeepArchived && (
          <OverlayTrigger
            overlay={
              <Tooltip>C+D discontinued this product — GDSN will not reactivate it.</Tooltip>
            }
            placement="top"
            delayShow={300}
            delayHide={150}
          >
            <span
              style={{
                backgroundColor: danger,
                color: white,
                padding: '2px 8px',
                borderRadius: 10,
                fontSize: 11,
                fontWeight: 600,
                marginLeft: 6,
                whiteSpace: 'nowrap',
              }}
            >
              Keep Archived
            </span>
          </OverlayTrigger>
        )}
      </td>
      <td>{manufacturer.manufacturer_sku || '-'}</td>
      <td>{manufacturer.cid}</td>
      <td>{manufacturer.name}</td>
      <td>{dayjs(manufacturer.date_created).format(DATE_FORMAT)}</td>
      <td className="text-center">
        {manufacturer.fsa_score ? manufacturer.fsa_score + ' %' : '-'}
      </td>
      <td>
        {linkTypeChangeLogLoading ? (
          <LoadingSpinner short={true} />
        ) : linkTypeChangeLog.length > 0 ? (
          linkTypeChangeLog[0].meta_data.link_type
        ) : (
          '-'
        )}
      </td>
      <td className="text-center">
        <VerificationStatusIcon
          verificationStatus={manufacturer.verification_status}
          aiSuggestedVerification={manufacturer.ai_suggested_verification}
        />
      </td>
      <td>
        <ProductUnlinkButton
          globalProductId={manufacturer.global_product.id}
          manufacturerProductIds={[manufacturer.id]}
          verificationStatus={manufacturer.verification_status}
          refetch={refetch}
          disabled={!isChecked}
        />
      </td>
    </tr>
  );
}

ManufacturerRow.propTypes = {
  manufacturer: PropTypes.object,
  refetch: PropTypes.func,
  selectedIds: PropTypes.object,
  setSelectedIds: PropTypes.func,
  linkTypeChangeLogLoading: PropTypes.bool,
  linkTypeChangeLog: PropTypes.array,
};

export default ManufacturerRow;
